import { Box, CircularProgress, Typography } from "@mui/material";
import React from "react";
import classes from "../../../styles/pujaMainCard.module.css";
function SubmitBtn({
  btnText,
  loading,
  postionFixed,
  setProps,
  disabled,
  animation = false
}) {
  return <div className={`${postionFixed ? classes.bookButtonContainer : classes.btnContainer}`} onClick={setProps} data-sentry-component="SubmitBtn" data-sentry-source-file="submitBtn.jsx">
      {!loading ? <button className={`${disabled ? classes.btnTextDisabled : animation ? classes.animatedBookButton : classes.bookButton}`}
    //className={classes.bookButton}
    type="submit" disabled={disabled}>
          <Typography color={disabled ? "#92A4AB" : "#ffffff"} className={classes.registrationBtn}>
            {btnText}
          </Typography>
        </button> : <Box className={classes.loaderBtn}>
          <CircularProgress color="inherit" size={"30px"} />
        </Box>}
    </div>;
}
export default SubmitBtn;